module.exports = __webpack_public_path__ + "img/home_do.b459a2fc.jpg";